export default __webpack_public_path__ + "static/media/block-distribute-horizontally.71b6f091.svg";